import * as Sentry from '@sentry/browser';
import { Severity } from '@sentry/browser';
import { ENVIRONMENT, MICROS_ENV, NODE_ENV, getEnvironment } from '@atlassian/temp-shared/environment';

export function initClient(reportingEndpoint: string | undefined) {
  if (reportingEndpoint && reportingEndpoint.length > 0 && String(getEnvironment()) !== 'local') {
    Sentry.init({
      dsn: reportingEndpoint,
      debug: true,
      environment: String(getEnvironment()),
      //TODO: Release
    });

    Sentry.configureScope((scope) => {
      scope.setTags({
        microsEnv: MICROS_ENV,
        nodeEnv: NODE_ENV,
      });

      scope.setLevel(Sentry.Severity.Warning);
    });
  }
}

export function captureException(ex: Error, payload?: Object) {
  if (payload) {
    Sentry.withScope((scope) => {
      Object.keys(payload).forEach((key) => {
        // @ts-ignore
        scope.setExtra(key, payload[key]);
      });

      Sentry.captureException(ex);
    });
  } else {
    Sentry.captureException(ex);
  }
}

export function captureErrorMessage(msg: string, payload?: any) {
  captureMessage(msg, payload, Severity.Error);
}

export function captureMessage(msg: string, payload: any, severity: Severity) {
  if (payload) {
    Sentry.withScope((scope) => {
      Object.keys(payload).forEach((key) => {
        scope.setExtra(key, payload[key]);
      });

      Sentry.captureMessage(msg, severity);
    });
  } else {
    Sentry.captureMessage(msg, severity);
  }
}
